import { IClient, IObra, IPeca } from "../../Obras/newObra/IObra";

export type IOrcamento = {
	id: number;
	client: IClient;
	name: string;
	observacoes?: string;
	vossaRequisicao?: string;
	importancia?: ImportanciaOrcamento;
	billCode: string;
	date: string;
	validade: string;
	valueWithoutIVA: number;
	valueWithIVA?: number;
	discardIVA: boolean;
	acceptedPercentage?: number;
	accepted: boolean;
	obras: Partial<IObra>[];
	pecasOrcamentadas: IPeca[];
	transporte: boolean;
	prazoDeEntrega?: string;
	pedidoOrcamento?: {
		id: number;
		subject: string;
		title: string;
		content: string;
	};
};

export enum ImportanciaOrcamento {
	SEM_IMPORTANCIA = "Sem importância",
	ALGUMA_IMPORTANCIA = "Alguma importância",
	MUITA_IMPORTANCIA = "Muita importância",
}
